import { __decorate, __extends, __metadata, __rest, __spreadArray } from "tslib";
import * as React from 'react';
import ComponentBase from './ComponentBase';
import { Components, Misc, Utils } from '@singularsystems/neo-core';
import Tooltip from './Tooltip';
import { observer } from 'mobx-react';
import { NeoReactTypes } from '../Modules/Types';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isExpanded: false };
        _this.btnGroupDom = React.createRef();
        _this.menuDom = React.createRef();
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        _this.windowClickHandler = _this.windowClicked.bind(_this);
        _this.showMenu = _this.showMenu.bind(_this);
        return _this;
    }
    Button.prototype.showMenu = function () {
        var _this = this;
        if (!this.state.isExpanded) {
            this.setState({ isExpanded: true });
            setTimeout(function () { return window.addEventListener("click", _this.windowClickHandler); }, 0);
        }
    };
    Button.prototype.hideMenu = function () {
        if (this.state.isExpanded) {
            this.setState({ isExpanded: false });
        }
        window.removeEventListener("click", this.windowClickHandler);
    };
    Button.prototype.menuItemClicked = function (e, data, userEvent) {
        this.hideMenu();
        e.preventDefault();
        if (userEvent) {
            userEvent(e, data);
        }
        else if (this.props.onClick && data !== undefined) {
            this.props.onClick(e, data);
        }
    };
    Button.prototype.windowClicked = function (e) {
        this.hideMenu();
    };
    Button.prototype.afterRender = function () {
        if (this.btnGroupDom.current && this.menuDom.current) {
            Components.PositionHelper.checkScreenBounds(this.btnGroupDom.current, this.menuDom.current, undefined, this.props.menuAlignment === "right");
        }
    };
    Button.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, isSubmit = _b.isSubmit, variant = _b.variant, size = _b.size, isOutline = _b.isOutline, icon = _b.icon, iconAlignment = _b.iconAlignment, text = _b.text, menuItems = _b.menuItems, splitMenu = _b.splitMenu, menuAlignment = _b.menuAlignment, buttonGroupClassName = _b.buttonGroupClassName, tooltip = _b.tooltip, task = _b.task, isBusy = _b.isBusy, pulse = _b.pulse, customVariant = _b.customVariant, native = __rest(_b, ["isSubmit", "variant", "size", "isOutline", "icon", "iconAlignment", "text", "menuItems", "splitMenu", "menuAlignment", "buttonGroupClassName", "tooltip", "task", "isBusy", "pulse", "customVariant"]);
        native.type = isSubmit ? "submit" : "button";
        var variantClassName = ((_a = customVariant !== null && customVariant !== void 0 ? customVariant : variant) !== null && _a !== void 0 ? _a : "primary");
        var isDropDown = menuItems && menuItems.length;
        var buttonClasses = "btn btn-" + (isOutline ? "outline-" : "") + variantClassName;
        if (size)
            buttonClasses += " btn-" + size;
        if (isDropDown && !splitMenu) {
            buttonClasses += " dropdown-toggle";
            native.onClick = this.showMenu;
        }
        var iconStyle = {};
        if (isBusy !== undefined || task !== undefined) {
            iconStyle = { fixedWidth: true };
        }
        if (isBusy || (task === null || task === void 0 ? void 0 : task.isBusy)) {
            iconStyle.fixedWidth = true;
            iconStyle.spin = true;
            icon = Misc.Settings.icons.loadingIcon;
            native.disabled = true;
        }
        if (pulse) {
            buttonClasses += " ".concat(variantClassName, "-color-pulse");
        }
        native.className = (native.className || "") + " " + buttonClasses;
        // Button text
        var innerText = this.props.children;
        if (!innerText)
            innerText = text;
        var iconSpace = icon && innerText ? " " : "";
        // Icon
        var iconElement = this.iconFactory.getIconComponent(icon, iconStyle);
        // Tooltip
        if (tooltip) {
            Tooltip.setDomProperties(native, tooltip);
        }
        var root;
        // Main button
        var buttonChildren = [];
        if (icon && iconAlignment !== "right")
            buttonChildren.push(iconElement, iconSpace);
        buttonChildren.push(innerText);
        if (isDropDown && !splitMenu) {
            buttonChildren.push(" ");
        }
        if (icon && iconAlignment === "right")
            buttonChildren.push(iconSpace, iconElement);
        var mainButton = React.createElement.apply(React, __spreadArray(["button", native], buttonChildren, false));
        var buttonGroupClasses = "btn-group";
        // add custom css classes to the button group if applicable
        if (buttonGroupClassName) {
            buttonGroupClasses = Utils.joinWithSpaces(buttonGroupClasses, buttonGroupClassName);
        }
        // Button needs a container if this is a drop down button
        if (isDropDown) {
            var menu = React.createElement("div", { className: "dropdown-menu" + (this.state.isExpanded ? " show" : ""), ref: this.menuDom }, menuItems.map(function (item, index) { return (item.header ? React.createElement("h6", { key: index, className: "dropdown-header" }, item.header)
                : item.isDivider ? React.createElement("div", { key: index, className: "dropdown-divider" })
                    : React.createElement("div", { key: index, className: "dropdown-item", onClick: function (e) { return _this.menuItemClicked(e, item.data, item.onClick); } },
                        _this.iconFactory.getIconComponent(item.icon, { fixedWidth: true }),
                        "  ",
                        item.text)); }));
            root =
                React.createElement("div", { className: buttonGroupClasses, ref: this.btnGroupDom },
                    mainButton,
                    splitMenu && React.createElement("button", { type: "button", onClick: this.showMenu, className: buttonClasses + " dropdown-toggle dropdown-toggle-split" }),
                    menu);
        }
        else {
            root = mainButton;
        }
        return root;
    };
    Button = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Button);
    return Button;
}(ComponentBase));
export default Button;
